import {Injectable} from '@angular/core';
import {environment} from "../../environments/environment";

import {Observable} from "rxjs";
import {Estado} from "../models/estado";
import {map} from "rxjs/operators";
import {HttpClient} from "@angular/common/http";
import {ConfiguracaoGrupoPlano} from "../models/configuracao-grupo-plano";
import {ConfiguracaoPlano} from "../models/configuracao-plano";
import {Meta} from "../models/meta";
import {Objetivo} from "../models/objetivo";
import {AcaoEstrategica} from "../models/acao-estrategica";
import {Avaliacao} from "../models/avaliacao";
import {OutraDefinicao} from "../models/outra-definicao";
import {Arquivo} from "../models/arquivo";

@Injectable({
    providedIn: 'root'
})
export class ConfiguracaoGrupoPlanoService {

    private api_url = environment.api_url + "/configuracao-grupo-plano";

    constructor(private http: HttpClient) {

    }

    listAll(cod_plano: number = null): Observable<ConfiguracaoGrupoPlano[]> {
        let url: string = this.api_url;
        if (cod_plano) {
            url += "/" + cod_plano;
        }
        return this.http.get(url).pipe(map((res: any) => {
            return res.data as Array<ConfiguracaoGrupoPlano>;
        }));
    }

    findBySigla(sigla: string, com_configuracoes_grupo: boolean = false): Observable<ConfiguracaoGrupoPlano> {
        let url: string = this.api_url + "/show/" + sigla;

        if (com_configuracoes_grupo) {
            let includes = [
                "configuracoes_plano",
                "configuracoes_plano.metas",
                "configuracoes_plano.objetivos",
                "configuracoes_plano.acoes_estrategicas",
                "configuracoes_plano.avaliacoes",
                "configuracoes_plano.outras_definicoes",
                "configuracoes_plano.arquivo",
            ];
            url += "/?include=" + includes.join(',');
        }
        return this.http.get(url).pipe(map((res: any) => {
            let configuracao_grupo_plano = res as ConfiguracaoGrupoPlano;
            if (res.configuracoes_plano && res.configuracoes_plano.data.length > 0) {
                let configuracoes_plano: Array<ConfiguracaoPlano> = [];
                res.configuracoes_plano.data.forEach((configuracao_plano: any) => {
                    configuracao_plano.metas = configuracao_plano.metas.data as Array<Meta>;
                    configuracao_plano.objetivos = configuracao_plano.objetivos.data as Array<Objetivo>;
                    configuracao_plano.acoes_estrategicas = configuracao_plano.acoes_estrategicas.data as Array<AcaoEstrategica>;
                    configuracao_plano.avaliacoes = configuracao_plano.avaliacoes.data as Array<Avaliacao>;
                    configuracao_plano.outras_definicoes = configuracao_plano.outras_definicoes.data as Array<OutraDefinicao>;
                    configuracao_plano.arquivo = configuracao_plano.arquivo as Array<Arquivo>;
                    configuracoes_plano.push(configuracao_plano as ConfiguracaoPlano);
                });
                configuracao_grupo_plano.configuracoes_plano = configuracoes_plano;
            }
            return configuracao_grupo_plano;
        }));
    }
}
